import { z } from "zod/v4";

export const ExperienceActionTypeList = [
  "start",
  "pause",
  "end",
  "delete",
] as const;
export type ExperienceActionType = (typeof ExperienceActionTypeList)[number];

export const ExperienceActionDtoSchema = z.object({
  id: z.uuid(),
  experienceId: z.uuid(),
  action: z.enum(ExperienceActionTypeList),
  actionTs: z.number(),
});

export type ExperienceActionDto = z.infer<typeof ExperienceActionDtoSchema>;
